import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { Language } from '../../../@ksm/language/model/language.model';
import { AppSettingConstant } from '../constants/app-setting.constant';
import { API } from '../../../@tpl-auth/constants/api';
import { LocalStorageConstant } from '../../../@tpl-auth/constants/local-storage.constant';
import { HttpProvider } from '@tpl-core/providers/http';

@Injectable({
    providedIn: 'root'
})
export class LanguageTranslateService {
    constructor(private translateService: TranslateService, private httpClient: HttpProvider) {}

    selectedLanguage = new Subject<string>();

    public changeLanguage(languageKey: string): void {
        this.translateService.use(languageKey);
        localStorage.setItem(LocalStorageConstant.languageKey, languageKey);
    }

  public getLanguages(): Observable<Language[]> {
    return this.httpClient.get<Language[]>(AppSettingConstant.baseUrl + API.languages);
  }

  public setLanguage(language: Language): void{
    this.changeLanguage(language.key);
    localStorage.setItem(LocalStorageConstant.languageKey, language.key);
    AppSettingConstant.selectedLanguage.next(language);
  }
}
